// src/components/ContactForm.js
import React, { useState } from 'react';

const encode = (data) =>
    Object.keys(data)
        .map(
            (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
        )
        .join('&');

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
        'bot-field': ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.message) {
            setError('Please fill out all fields.');
            return;
        }

        if (formData['bot-field']) {
            // If bot-field is filled, probably spam, just ignore
            return;
        }

        setError('');

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({
                'form-name': 'contact',
                ...formData,
            }),
        })
            .then(() => {
                setSubmitted(true);
                setFormData({ name: '', email: '', message: '', 'bot-field': '' });
            })
            .catch(() => setError('Failed to send message. Please try again later.'));
    };

    return (
        <div style={{ maxWidth: '600px', margin: '60px auto', textAlign: 'center' }}>
            {/* Profile Picture */}
            <img
                src="/images/pfp.png"
                alt="Mark Veerasingam"
                style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginBottom: '20px',
                    border: '2px solid #848884',
                }}
            />

            {submitted ? (
                <p>Thanks for reaching out! I'll get back to you soon.</p>
            ) : (
                <form
                    name="contact"
                    netlify
                    netlify-honeypot="bot-field"
                    onSubmit={handleSubmit}
                    noValidate
                    style={{ textAlign: 'left' }}
                >
                    {/* Hidden input for Netlify */}
                    <input type="hidden" name="form-name" value="contact" />
                    {/* Honeypot field for bots */}
                    <p style={{ display: 'none' }}>
                        <label>
                            Don’t fill this out if you're human:{' '}
                            <input
                                name="bot-field"
                                value={formData['bot-field']}
                                onChange={handleChange}
                            />
                        </label>
                    </p>

                    <div style={{ marginBottom: '1rem' }}>
                        <label htmlFor="name">Name:</label>
                        <br />
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', fontSize: '1rem' }}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                        <label htmlFor="email">Email:</label>
                        <br />
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', fontSize: '1rem' }}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: '1rem' }}>
                        <label htmlFor="message">Message:</label>
                        <br />
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            value={formData.message}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', fontSize: '1rem' }}
                            required
                        />
                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>}

                    <div className="button-container">
                        <button className="simple-button"
                            type="submit"
                            style={{ padding: '10px 20px', fontSize: '1rem', cursor: 'pointer' }}
                        >
                            Send Message
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default ContactForm;
